export default __webpack_public_path__ + "static/media/lohse.90710622.png";